export let Rulemanager = {
    path: 'rulemanager',
    name: 'rulemanager',
    meta: {
        roleCode: '011',
    },
    component: () =>
        import(/*webpackChunkName:"rule-page"*/ '@/views/back-stage/rule-manager/rule-page.vue'),
};
